import camelCase from 'lodash.camelcase';
import startCase from 'lodash.startcase';

export const pascalCase = (str: string): string => {
    return startCase(camelCase(str)).replace(/ /g, '');
};

export const convertPascalCaseToKebabCase = (str: string): string => {
    return str.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();
};
